const my = {
  path: 'my',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/my'], resolve)
}
export default my
